// src/api/v2/admins.js
import { http } from './http';

export async function login(email, password) {
  const { json } = await http('/api/v2/admins/login', {
    method: 'POST',
    body: { email, password },
  });
  // prefer token from body to avoid any header/CORS quirks
  if (!json?.token) throw new Error('No token returned');
  localStorage.setItem('bagspa_token', json.token);
  localStorage.setItem('adminId', json.admin.id);
  return json.admin; // { id, first_name, role }
}

export async function profile() {
  const { json } = await http('/api/v2/admins/profile');
  return json?.admin;
}

// Optional server logout. If your API doesn’t have it, we ignore errors and
// still clear the client token so the UI logs out.
export async function logout() {
  try {
    await http.post('api/v2/admins/logout') // ok if 404 / not implemented
  } catch (_) {
    // ignore
  } finally {
    localStorage.removeItem('bagspa_token')
    delete http.defaults.headers.common.Authorization
  }
  return true
}
